export const slides = [`${process.env.REACT_APP_MEDIA_STATIC_ASSETS}/avatar-gallery.jpg`]
